import type { VizGraph } from './types';

const idOf = (end: unknown): string =>
  typeof end === 'object' && end !== null ? (end as { id: string }).id : (end as string);

/** The selected node plus its direct neighbours; null when nothing is selected. */
export function highlightSet(data: VizGraph, selectedId?: string | null): Set<string> | null {
  if (!selectedId) return null;
  const set = new Set<string>([selectedId]);
  for (const l of data.links) {
    const s = idOf(l.source);
    const t = idOf(l.target);
    if (s === selectedId) set.add(t);
    if (t === selectedId) set.add(s);
  }
  return set;
}

export function linkActive(link: { source: unknown; target: unknown }, selectedId?: string | null): boolean {
  if (!selectedId) return true;
  return idOf(link.source) === selectedId || idOf(link.target) === selectedId;
}
